// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import sumBy from 'lodash/sumBy'
import moment from 'moment'
import React from 'react'
import { i18n } from '../../index'
import DayRow from './DayRow'
import css from './incentiveSales.css'
import type { DailySalesIncentiveReport } from './types'
import WeekSummaryRow from './WeekSummaryRow'
type Props = {
  data: Array<DailySalesIncentiveReport>
  hasExpressCheckout?: boolean
}

const IncentiveSalesTable = ({ data, hasExpressCheckout = false }: Props) => {
  const monthSummaryData = {
    euroTarget: Math.round(sumBy(data, 'euroTarget')),
    euroActual: Math.round(sumBy(data, 'euroActual')),
    piecesTarget: Math.round(sumBy(data, 'piecesTarget')),
    piecesActual: Math.round(sumBy(data, 'piecesActual')),
    mojovaEuroActual: Math.round(sumBy(data, 'mojovaEuroActual')),
    kassuEuroActual: Math.round(sumBy(data, 'kassuEuroActual')),
    expressCheckoutEuroActual: Math.round(sumBy(data, 'expressCheckoutEuroActual')),
    chainTarget: Math.round(sumBy(data, 'chainTarget')),
  }
  return (
    <table className={css.table}>
      <thead>
        <tr>
          <th />
          <th>{i18n.t('reporting.label.incentiveSales.chainTarget')}</th>
          <th>{i18n.t('reporting.label.incentiveSales.euroTarget')}</th>
          <th>{i18n.t('reporting.label.incentiveSales.euroActual')}</th>
          <th>{i18n.t('reporting.label.incentiveSales.kassu')}</th>
          <th>{i18n.t('reporting.label.incentiveSales.mojova')}</th>
          {hasExpressCheckout && <th>{i18n.t('reporting.label.incentiveSales.expressCheckout')}</th>}
        </tr>
      </thead>
      <tbody>
        <tr className={css.monthRow}>
          <td>{i18n.t('budgetPlanning.table.wholeMonth')}</td>
          <td className={css.monthCellHighlight}>{monthSummaryData.chainTarget}</td>
          <td className={css.monthCellHighlight}>{monthSummaryData.euroTarget}</td>
          <td className={css.monthCellHighlight}>{monthSummaryData.euroActual}</td>
          <td className={css.monthCellHighlight}>{monthSummaryData.kassuEuroActual}</td>
          <td className={css.monthCellHighlight}>{monthSummaryData.mojovaEuroActual}</td>
          {hasExpressCheckout && (
            <td className={css.monthCellHighlight}>{monthSummaryData.expressCheckoutEuroActual}</td>
          )}
        </tr>
        {data.map((singleDayData, index) => {
          const isSunday = moment(singleDayData.date).day() === 0
          let weekSummaryData = {}

          if (isSunday) {
            const weekData = data.slice(Math.max(index - 6, 0), index + 1)
            weekSummaryData = {
              week: moment(singleDayData.date).week(),
              euroTarget: Math.round(sumBy(weekData, 'euroTarget')),
              chainTarget: Math.round(sumBy(weekData, 'chainTarget')),
              euroActual: Math.round(sumBy(weekData, 'euroActual')),
              piecesTarget: Math.round(sumBy(weekData, 'piecesTarget')),
              piecesActual: Math.round(sumBy(weekData, 'piecesActual')),
              mojovaEuroActual: Math.round(sumBy(weekData, 'mojovaEuroActual')),
              kassuEuroActual: Math.round(sumBy(weekData, 'kassuEuroActual')),
            }
            if (hasExpressCheckout) {
              weekSummaryData.expressCheckoutEuroActual = Math.round(sumBy(weekData, 'expressCheckoutEuroActual'))
            }
          }

          return (
            <React.Fragment key={index}>
              <DayRow data={singleDayData} hasExpressCheckout={hasExpressCheckout} />
              {isSunday && <WeekSummaryRow data={weekSummaryData} hasExpressCheckout={hasExpressCheckout} />}
            </React.Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

export default IncentiveSalesTable
